import { render, staticRenderFns } from "./TrendDownIcon.vue?vue&type=template&id=0107c0ce&scoped=true&"
import script from "./TrendDownIcon.vue?vue&type=script&lang=js&"
export * from "./TrendDownIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrendDownIcon.vue?vue&type=style&index=0&id=0107c0ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107c0ce",
  null
  
)

export default component.exports